import React, { useRef, useEffect } from "react";
import { useSpring, animated, to } from "@react-spring/web";
import { useGesture } from "react-use-gesture";

import "../css/styles.css";

const calcX = (y, ly) => {
  if (y < 0 || ly < 0) return;
  return -(y - ly - window.innerHeight / 2) / 250;
};
const calcY = (x, lx) => {
  if (x < 0 || lx < 0) return;
  return (x - lx - window.innerWidth / 1.5) / 250;
};

const wheel = (y) => {
  const imgHeight = window.innerWidth * 0.3 - 20;
  return `translateY(${-imgHeight * (y < 0 ? 6 : 1) - (y % (imgHeight * 5))}px`;
};

export default function HoverCard({ image }) {
  //////////////////////////////////////////////////////////////////////
  useEffect(() => {
    const preventDefault = (e) => e.preventDefault();
    console.log("---------------->", image);
    document.addEventListener("gesturestart", preventDefault);
    document.addEventListener("gesturechange", preventDefault);

    return () => {
      document.removeEventListener("gesturestart", preventDefault);
      document.removeEventListener("gesturechange", preventDefault);
    };
  }, []);

  const domTarget = useRef(null);
  const [{ x, y, rotateX, rotateY, rotateZ, zoom, scale }, api] = useSpring(
    () => ({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
      config: { mass: 5, tension: 350, friction: 40 },
    })
  );

  const [{ wheelY }, wheelApi] = useSpring(() => ({ wheelY: 0 }));

  useGesture(
    {
      // onDrag: ({ active, offset: [x, y] }) =>
      //   api({ x, y, rotateX: 0, rotateY: 0, scale: active ? 1 : 1.1 }),
      // onPinch: ({ offset: [d, a] }) => api({ zoom: d / 500, rotateZ: a }),
      onMove: ({ xy: [px, py], dragging }) =>
        !dragging &&
        api({
          rotateX: calcX(py, y.get()),
          rotateY: calcY(px, x.get()),
          scale: 1.01,
        }),
      onHover: ({ hovering }) =>
        !hovering && api({ rotateX: 0, rotateY: 0, scale: 1 }),
      onWheel: ({ event, offset: [, y] }) => {
        event.preventDefault();
        wheelApi.set({ wheelY: y });
      },
    },
    { domTarget, eventOptions: { passive: false } }
  );
  /////////////////////////////////////////////////////////////////////

  return (
    <div className="containerX">
      <animated.div
        ref={domTarget}
        className="cardX"
        style={{
          transform: "perspective(600px)",
          x,
          y,
          scale: to([scale, zoom], (s, z) => s + z),
          rotateX,
          rotateY,
          rotateZ,
          backgroundImage: `url(${image}.png)`,
        }}
      >
        <animated.div
          style={{ transform: wheelY.to(wheel) }}
          className="d-flex justify-content-center"
        >
          <img alt="" src="" width="100px" height="100px" />
        </animated.div>
      </animated.div>
    </div>
  );
}
